import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import { UserActivityTrackCredentials } from "@plugins/user-activity-track/types.ts";

export default {
  fetchCredentials(): Promise<ApiResponse<UserActivityTrackCredentials>> {
    return httpClient.get(`/apis/user-activity-track/credentials`);
  },
};
